import * as Accordion from "@radix-ui/react-accordion";
import React from "react";
import SVG from "react-inlinesvg";

import { CompareFeatureBlock } from "@reactivated";

import ArrowDownIcon from "../../../../img/icons/arrow_down.svg";
import { RichText } from "../../../common/RichText";
import { CompareFeatureRow } from "../elements/CompareFeatureRow";
import { CompareFeatureTooltip } from "../elements/CompareFeatureTooltip";

import styles from "./index.module.scss";

interface ICompareFeatureProps {
    features: CompareFeatureBlock[];
    compareTileFeatures?: CompareFeatureBlock[][];
}

export const CompareFeature = (props: ICompareFeatureProps) => {
    if (!props.compareTileFeatures) {
        return null;
    }
    return (
        <div className={styles.compareFeaturesContainer}>
            <Accordion.Root
                type="multiple"
                defaultValue={props.features.map(
                    (ftr) => ftr.icon?.title || "",
                )}
            >
                {props.features.map((ftr) => (
                    <Accordion.Item
                        key={ftr.icon?.title}
                        value={ftr.icon?.title || ""}
                        className={styles.accordionItem}
                    >
                        <Accordion.Trigger>
                            <div className={styles.accordionTrigger}>
                                <SVG src={ArrowDownIcon} className="arrow" />
                                <RichText html={ftr.feature?.title || ""} />
                                <CompareFeatureTooltip
                                    tooltip={ftr.feature?.tooltip || ""}
                                />
                            </div>
                        </Accordion.Trigger>
                        <Accordion.Content>
                            <CompareFeatureRow
                                feature={ftr}
                                content={props.compareTileFeatures?.map(
                                    (ctf) =>
                                        ctf.find(
                                            (item) =>
                                                item.feature?.title ===
                                                ftr.feature?.title,
                                        ) || null,
                                )}
                            />
                        </Accordion.Content>
                    </Accordion.Item>
                ))}
            </Accordion.Root>
        </div>
    );
};
